@if (!isSubmitted()) {
<div>
    <div class="flex-between-top">
        <div class="submit-confirmation-title">
            <p class="order-step-content-subtitle" [data-testing]="'submit-confirmation-message'">
                @if (!store.order?.wetSign) {
                <span>{{ literals[approvalType()]?.title }}</span>
                } @if (store.order?.wetSign) {
                <span>{{ literals[approvalType()]?.titleWetSign }}</span>
                }
            </p>
        </div>
    </div>

    @if (orderNumber) {
    <aix-header-section [sectionClasses]="'u-mt24'" [title]="'Order #' + orderNumber">
    </aix-header-section>
    }

    <aix-formlist
        [isReadOnly]="isReadOnly()"
        [order]="(store.orderSuccess$ | async)"
        [orderFormComments]="(store.orderFormCommentsSuccess$ | async) | orderFormCommentsFilter:false:false:undefined:commentTag.change"
        [title]="'Required Forms'"
        [clickable]="true"
        [includeRemove]="true"
        (clickElem)="goToForm($event)"
        (onRemove)="removeDocument($event)"
    >
    </aix-formlist>

    <div class="flex-between-center u-mt64" [data-testing]="'filelist-header'">
        <div class="-heading">
            <h5 [data-testing]="'upload-documents-title'">Supporting Documents</h5>
        </div>
    </div>

    <aix-file-upload
        class="u-block"
        #orderFileUpload
        [data-testing]="'supporting-documents-upload'"
        [enableIgnore]="true"
        [innerUpload]="!unfinishedRequiredUploads && this.store?.order?.status !== orderStatus.pendingManualSubmission"
        [isReadOnly]="isReadOnly()"
        [displayComponentHeader]="false"
        [orderFileComments]="(store.orderFormCommentsSuccess$ | async) | orderFormCommentsFilter:false:false:undefined:commentTag.change"
    >
    </aix-file-upload>

    <div class="flex-between-center u-mt64" [data-testing]="'order-note-header'">
        <div class="-heading">
            <h5 [data-testing]="'order-note-title'">Note</h5>
        </div>
    </div>
    <p class="order-step-content-subtitle" [data-testing]="'order-note-description'">
        Optionally add a note to this order. It will appear in the order's comments.
    </p>
    <aix-textarea
        [config]="{ placeholder: 'Add a note (optional)', refId: 'orderNote' }"
        [showLabel]="false"
        [height]="120"
        [isDisabled]="isReadOnly()"
        (valueChanges)="onNoteChange($event)"
    >
    </aix-textarea>
    @if (isNoteTooLong) {
    <p class="submit-confirmation-error" [data-testing]="'order-note-error'">
        Note cannot be longer than {{ noteMaxLength }} characters.
    </p>
    }

    <aix-notification
        #notificationRef
        [data-testing]="'submitNotification'"
        [isOpen]="false"
        [canClose]="true"
        status="warning"
        [classList]="['u-mt16']"
    >
        All supporting documents must be uploaded or ignored to continue.
    </aix-notification>
    <div class="aix-toolbar u-mt24">
        @if (literals[approvalType()]?.buttonText) {
        <aix-button
            [data-testing]="'submit'"
            [isDisabled]="isReadOnly() || isAboveTotalFileSize"
            (click)="showConfirmation()"
            [buttonType]="showConfirmationButtonType"
            [buttonLabel]="literals[approvalType()]?.buttonText"
        >
        </aix-button>
        }
    </div>

    @if (error && !isSending) {
    <div class="flex-center-center u-mt24 submit-confirmation-error">
        <p>{{ literals[approvalType()]?.completedError }}</p>
    </div>
    }
</div>
}

<aix-modal
    #submitOrderModal
    modalType="confirmation"
    [modalTitle]="'Submit order?'"
    (optionSelected)="submitOrderModalSelected($event)"
>
    <ng-template>
        <p>This order will be submitted for processing.</p>
    </ng-template>
</aix-modal>

<aix-modal
    #manualSubmissionModal
    modalType="confirmation"
    [modalTitle]="'Submit order offline?'"
    (optionSelected)="submitOrderModalSelected($event)"
>
    <ng-template>
        <div class="order-detail-modal">
            <p class="u-fw500">This order will be downloaded and marked as offline.</p>
            <p>Please submit the order according to your firm's processes.</p>
        </div>
    </ng-template>
</aix-modal>
